import React, { useState } from 'react';

import { RadiosField, PopoverMenu, RadioField, MCButton } from 'src/components/basic';

import { lang, objectToSelectList, remCss, useLanguage } from 'src/helpers';
import ContactsList from './contact/list';
import LANG_CONST from 'src/helpers/lang/const';

export const PrivacySetting = React.memo(
  ({ onChange, data, buttonProps = null, placement = 'bottom-end', title, label }) => {
    const [customOpen, setCustomOpen] = useState(0);
    const [userIds, setUserIds] = useState(data?.userIds || []);
    const [choseTemp, setChoseTemp] = useState(data?.type);
    useLanguage();

    const list = objectToSelectList(LANG_CONST.constants.privacy_setting);
    return (
      <PopoverMenu
        style={{ cursor: 'pointer' }}
        placement={placement}
        possiblePlacements={[placement, 'top-end']}
        triggerOffset={10}
        popupMenuStyle={{
          overflow: 'none'
        }}
        onClose={(isOpen) => {
          if (isOpen) {
            setCustomOpen(-1);
          } else {
            setCustomOpen(0);
          }
          setUserIds(data?.userIds || []);
        }}
        menu={(close) => (
          <div
            className={'mc-p20 mc-flex-5-col'}
            style={{
              backgroundColor: 'white',
              borderRadius: remCss(10)
            }}
          >
            {!customOpen ? (
              <>
                <RadiosField
                  list={list.map((item) => ({
                    ...item,
                    loading: choseTemp !== data?.type && choseTemp === item.value
                  }))}
                  data={choseTemp === data?.type && data?.type}
                  onChange={(v) => {
                    setChoseTemp(v);
                    onChange({ ...data, type: v });
                  }}
                  template={'4'}
                />
                <RadioField
                  label={LANG_CONST.custom}
                  loading={choseTemp !== data?.type && choseTemp === 'custom'}
                  checked={choseTemp === data?.type && data?.type === 'custom'}
                  template={'4'}
                  onClick={() => {
                    setCustomOpen(1);
                  }}
                />
              </>
            ) : (
              customOpen === 1 && (
                <>
                  <ContactsList
                    title={title}
                    style={{ height: remCss(500), width: remCss(300) }}
                    data={userIds}
                    onChange={(userIds) => {
                      setUserIds(userIds);
                    }}
                    onClose={close}
                  />
                  <div className='mc-flex mc-p10 mc-mt20'>
                    <div className={'mc-grow'} />
                    <MCButton
                      light
                      radius
                      medium
                      primary
                      onClick={() => {
                        setCustomOpen(0);
                      }}
                    >
                      {lang.t(LANG_CONST.buttons.cancel)}
                    </MCButton>
                    <MCButton
                      dark
                      radius
                      medium
                      primary
                      onClick={() => {
                        setCustomOpen(0);
                        setChoseTemp('custom');
                        onChange({ userIds, type: 'custom' });
                      }}
                    >
                      {lang.t(LANG_CONST.buttons.save)}
                    </MCButton>
                  </div>
                </>
              )
            )}
          </div>
        )}
      >
        {() => (
          <MCButton
            light
            primary
            radius
            hover={true}
            medium
            label={label || LANG_CONST.buttons.privacy_setting}
            {...buttonProps}
          />
        )}
      </PopoverMenu>
    );
  }
);
PrivacySetting.displayName = 'PrivacySetting';
